import { CLASSES, SELECTORS, EVENTS } from '../config/constants';

export default function () {
  const accordionBodyElems = document.querySelectorAll(SELECTORS.ACCORDION.BODY);

  if (accordionBodyElems.length) {
    watchStateChange(accordionBodyElems);
  }
}

function watchStateChange(elems) {
  const events = [EVENTS.BS.COLLAPSE.SHOW, EVENTS.BS.COLLAPSE.HIDE];
  const elemsArr = Array.from(elems);

  events.forEach((eventName) => {
    window.addEventListener(eventName, ({ target }) => {
      if (!elemsArr.includes(target)) {
        return;
      }

      toggleCardClass(target);
    });
  });
}

function toggleCardClass(target) {
  const cardEl = target.closest(SELECTORS.ACCORDION.CARD);

  if (!cardEl) {
    return;
  }

  cardEl.classList.toggle(CLASSES.ACTIVE);
}
